const resources = {
  eu: {
    translation: {
      langSwitch: {
        se: "Sweden / SEK",
        dk: "Denmark / DKK",
        eu: "Rest of Europe / EUR",
        no: "Norway / NOK",
        nl: "Netherland / EUR",
        fr: "France / EUR",
        uk: "United Kingdom / GBP",
        changeCountry: "Change country",
        terms: "Terms",
        chooseCountry: "Choose country",
        freeDelivery: "Always free delivery",
        freeDeliveryText: "On all orders",
        freeDeliveryTime: "1-5 days home delivery",
        return: "Returns",
        returnText: "",
        currencyText: "Currency",
        currency: "EUR"
      },
      cookie: {
        text: "To give you the best user experience we are using Cookies. Learn more about Cookies via our",
        linkText: "Privacy Policy",
        link: "conditions"
      },
      thankYou: {
        thanks: "Thank you",
        placed: "Your order has been placed",
        receipt: "Your receipt will be sent to",
        info: "Your information",
        orderNumber: "Your order number is",
        loading: "loading",
        goBack: "Go back to"

      },
      checkout: {
        checkout: "Checkout",
        orderSum: "Your order",
        coupon: "Have a coupon",
        addCoupon: "Apply it here",
        apply: "Apply",
        yourCoupon: "Your coupon",
        discount: "Discount",
        total: "Total",
        priceBeforeDiscount: "Subtotal",
        remove: "Remove",
        edit: "Change",
        change: "Edit",
        email: "E-mail",
        yourEmail: "Your E-mail address",
        name: "Name",
        firstName: "First name",
        lastName: "Last name",
        address: "Address",
        street: "Street and house number",
        CO: "C/O",
        zip: "Zip code",
        city: "City",
        country: "Country",
        states: "Province",
        phone: "Phone",
        phoneNumber: "Your phone number",
        save: "Save & Continue",
        delivery: "Choose Shipping Method",
        marquee1: "Christmas gift guarantee - purchase on approval until april 3",
        marquee2: "Free shipping & Free returns",
        marquee3: "2 years warranty",
        marquee4: "Successful Christmas gift guarantee",
        tax: "Tax",
        paymentMethod: "Payment method",
        maintenance: "Flowlife undergoes scheduled maintenance. Deliveries are sent week 40"
      },
      member: {
        female: "Female",
        male: "Male",
        other: "Other",
        wontSay: "Don't want to say",
        email: "Email",
        emailInput: "Your email address",
        phone: "Phone",
        phoneInput: "Your phone number",
        birthday: "Birthday",
        gender: "Gender",
        ref: "How did you learn about Flowlife?",
        subject: "What segment are you interested in?",
        accept1: "I agree with the ",
        accept2: "terms and conditions",
        choose: "Choose",
        button: "To the deals!",
        day: "Day",
        month: "Month",
        year: "Year",
        climbing: "Climbing",
        crossfit: "Crossfit",
        ski: "Skiing",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Hiking",
        padel: "Padel",
        cycling: "Cycling",
        running: "Running",
      },
      blog: {
        featured: "Featured",
        latest: "Latest news",
        topStories: "Top stories",
        loadMore: "Load more",
        noResults: "No more results",
        products: "Products in this article"
      },
      switcher: {
        market: "Choose language and market",
        country: "Choose Country",
        terms: "Terms",
        rightOfReturn: "-days money-back guarantee",
        currency: "Currency",
        allOrders: "On all orders",
        change: "Change Country",
        sweden: "Sweden",
        international: "Rest of Europe",
        denmark: "Denmark",
        norway: "Norway",
        netherlands: "Netherlands",
        france: "France",
        uk: "United Kingdom",
        homeDelivery: "8-12 days delivery, Only inside the European Union"
      },
      ambassador: {
        title1: "Our athletes",
        title2: "Organizations we support",
        link2: "The Olympic Committee",
        link3: "Organizations"
      },
      mobileMenu: {
        products: "Products",
        about: "About",
        follow: "Follow us",
        support: "Support",
        menu: "Menu",
        more: "More"
      },
      miniCart: {
        youCart: "Your Cart",
        empty: "Your cart is empty",
        emptyCart: "Empty cart",
        continueShopping: "Continue shopping",
        shipping: "Shipping",
        paySafe: "Pay safely with",
        and: "and",
        continue: "Proceed to checkout",
        more: "Anything else",
        subTotal: "Subtotal",
        payment1: "payPal",
        payment2: "mvisa",
        free: "Free",
        compatible: "Compatible with your order",
        quickAdd: "Added to cart"
      },
      shop: {
        title1: "Bestsellers",
        title2: "Recovery",
        title3: "Performance",
        title4: "Accessories",
        title5: "Yoga",
        title6: "Bundles",
        title7: "Deals",
        title8: "Reuse",
        title9: "Events",
        title10: "Red Light Therapy",
      },
      slug: {
        product: "product",
        blog: "blog",
        compare: "compare",
        category: "category",
        ourStory: "our-story",
        massageGuns: "massage-guns",
        januari: "January sale",
        winter: "winter deals",
        spring: "Spring deals",
        easter: "Easter deals",
        title1: "bestsellers",
        title2: "recovery",
        title3: "performance",
        title4: "accessories",
        title5: "yoga",
        title6: "bundles",
      },
      faq: {
        button: "All questions and answers",
        link: "https://support.flowlifesweden.com/hc/en-us"
      },
      productInfo: {
        home: "Home",
        readMore: "Read more",
        buyNow: "Buy now",
        preOrder: "Pre-order",
        bundleInclude: "Included",
        newPrice: "New price",
        exVat: "Excl. VAT",
        bestTest: "Best in test",
        oos: "Out of stock",
        inStock: "In stock",
        lowStock: "Low in stock",
      },
      productTabs: {
        experience: "Shopping experience",
        desc: "Description",
        info: "Technical information",
        box: "What's in the box?",
        instructions: "Instructions",
        faq: "FAQ"
      },
      productCard: {
        addToCart: "Add to cart",
        readMore: "Read more about the product",
        setSize: "Select Size",
        setColor: "Select Color",
        bestseller: "Bestseller",
      },
      compare: {
        anchorLink: "To the test",
        button: "To the test",
        headLine: "Compare our massage guns",
        grade: "Grade",
        battery: "Battery",
        batteryLife: "Battery life",
        loadTime: "Load time",
        batteryType: "Battery type",
        performance: "Performance",
        stroke: "Stroke length",
        beats: "Beats per minute",
        motor: "Motor",
        noise: "Noise level",
        pressure: "Maximum pressure",
        spec: "Specifications",
        weight: "Weight",
        size: "Case size",
        dimensions: "Dimensions",
        bag: "Bag Included",
        charger: "Charger",
        nozzle: "Number of nozzles"
      },
      megaNav: {
        dontMiss: "Don't miss",
        allProducts: "Show all products"
      },
      marquee: {
        days: "days",
        free: "Free",
        shipping: "Shipping",
        always: "Always",
        freePlural: "Free",
        satisfaction: "Customer satisfaction guaranteed",
        returns: "Returns",
        guarantee: "years warranty",
        deals: "CHRISTMAS DEALS",
        fest: "Happy Monday",
        bonanza: "BLACK WEEK BONANZA",
        now: "Buy now",
        bf: "MERRY CHRISTMASSAGE",
        find: "LET IT FLOW",
        best: "Super deals",
        cm: "CYBER MONDAY ENDS ON MONDAY THE 29/11 AT 23.59",
        last: "Extended sale",
        christmas: "Christmas gift guarantee",
        christmas2: "Purchase on approval until April 3",
        merry: "Merry Christmas",
        allWeek: "Christmas all day every day",
        middle: "Christmas sale",
        really: "The gifts you really wanted",
        middleDeals: "After Christmas Sale",
        newYear: "Happy New Flow",
        janSale: "SALE",
        company: "Company offers"
      },
      reviews: {
        reviews: "Reviews",
        seeReviews: "See all reviews",
        users: "Reviews from users for"
      },
      voucher: {
        success: "Your coupon was applied",
        error: "Something went wrong...",
        removed: "Your coupon was removed"
      },
      widgets: {
        topics: "Explore topics",
        subscribe: {
          title: "Subscribe",
          description: "Things are better as a Flow Member. Get first and exclusive access to the newest styles & innovation",
          label: "Sign me up",
          typeform: "SFqzvXJY"
        },
        followus: "Follow Us"
      },
      footer: {
        follow: "Follow",
        service: "Service",
        info: "Info",
        column1: {
          title: "Subscribe",
        },
        column2: {
          title: "Get help"
        },
        column3: {
          title: "Information"
        }
      },
      vip: {
        input: "Your Email address...",
        button: "Sign Up",
        title: "Black Week Early Access",
        subtitle: "Sign up to get early access for Black Week"
      },
      tracking: {
        search: "Track order",
        placeholder: "Order number",
        headline: "Track your order",
        subtitle: "Enter you order number to track your order",
        content: "Donec posuere vulputate arcu aenean posuere tortor sed cursus feugiat.",
        back: "Search again"
      },
      returns: {
        register: "Register return"
      },
      header: {
        assitance: "Assistance",
        assitanceLink: "https://support.flowlifesweden.com/hc/en-us",
      },
      search: {
        shopAll: "Shop all",
        allFilters: "All filters",
        filter: "Filter",
        clear: "Clear filters",
        bodyPart: "Body part",
        misc: "Misc",
        showResults: "Show results",
        price: "Price",
        search: "Search",
        popularSearches: "Popular searches",
        suggestions: "Suggestions",
        close: "Close",
        pillow: "Massage pillow",
        pillowSlug: "massage-pillow",
        gun: "Massage guns",
        gunSlug: "massage-guns",
        feet: "Foot massage",
        feetSlug: "foot-massager",
        pression: "Compression therapy",
        pressionSlug: "flowpression-products",
        panels: "Red light therapy",
        panelsSlug: "red-light-therapy",
        tens: "TENS",
        tensSlug: "tens",
      }
    }
  },
  se: {
    translation: {
      langSwitch: {
        se: "Sverige / SEK",
        dk: "Denmark / DKK",
        eu: "Rest of Europe / EUR",
        no: "Norway / NOK",
        nl: "Netherland / EUR",
        fr: "France / EUR",
        uk: "United Kingdom / GBP",
        changeCountry: "Byt land",
        terms: "Villkor",
        chooseCountry: "Välj land",
        freeDelivery: "Alltid gratis leverans",
        freeDeliveryTextText: "På alla beställnigar",
        freeDeliveryTime: "1-3 dagars leverans",
        return: "Retur",
        returnText: "100 dagars nöjdkundgaranti",
        currencyText: "Valuta",
        currency: "SEK"
      },
      cookie: {
        text: "För att ge dig den bästa användarupplevelsen använder vi Cookies. Läs mer om Cookies under våra",
        linkText: "Köpvillkor",
        link: "kopvillkor"
      },
      thankYou: {
        thanks: "Tack",
        placed: "Vi har mottagit din order",
        receipt: "Ditt kvitto kommer skickas till",
        info: "Dina uppgifter",
        orderNumber: "Ditt ordernummer är",
        loading: "laddar",
        goBack: "Tillbaka till"
      },
      checkout: {
        checkout: "Kassa",
        orderSum: "Ordersummering",
        coupon: "Har du en rabattkod",
        addCoupon: "Lägg till den här",
        apply: "Använd",
        yourCoupon: "Lägg till rabattkod",
        discount: "Rabatt",
        total: "Total",
        priceBeforeDiscount: "Pris",
        remove: "Ta bort",
        edit: "Ändra",
        email: "E-mail",
        yourEmail: "Din email-adress",
        name: "Namn",
        firstName: "Förnamn",
        lastName: "Efternamn",
        address: "Adress",
        street: "Gata och husnummer",
        CO: "C/O",
        zip: "Postnummer",
        city: "Stad",
        country: "Land",
        states: "Provins",
        phone: "Telefon",
        phoneNumber: "Ditt telefonnummer",
        save: "Spara och fortsätt",
        delivery: "Välj Leverans",
        marquee1: "JULKLAPPSGARANTI - KÖP & PROVA PRODUKTEN TILL 3 april",
        marquee2: "Fri frakt över 500 SEK & fria returer",
        marquee3: "Alltid 2 års garanti",
        marquee4: "Lyckad julklappsgaranti",
        tax: "Varav moms",
        paymentMethod: "Betalningsmetod",
        maintenance: "Flowlife genomgår planerat underhåll. Leveranser skickas först v.40"
      },
      member: {
        female: "Kvinna",
        male: "Man",
        other: "Annat",
        wontSay: "Vill inte säga",
        email: "E-post",
        emailInput: "Din E-post",
        phone: "Telefon",
        phoneInput: "Ditt telefonnummer",
        birthday: "Födelsedag",
        gender: "Kön",
        ref: "Vad fick dig att tänka på oss idag?",
        subject: "Vilka aktiviteter önskar du att bli updaterad om?",
        accept1: "Jag godkänner de ",
        accept2: "allmänna villkoren",
        choose: "Välj",
        button: "Skapa konto",
        day: "Dag",
        month: "Månad",
        year: "År",
        climbing: "Klättring",
        crossfit: "Crossfit",
        ski: "Skidor",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Vandring",
        padel: "Padel",
        cycling: "Cykling",
        running: "Löpning",
      },
      blog: {
        featured: "Utvalda artiklar",
        latest: "Senaste nyheterna",
        topStories: "Mest lästa artiklar",
        loadMore: "Ladda fler",
        noResults: "Inga fler resultat",
        products: "Produkter i detta inlägg"
      },
      switcher: {
        market: "Välj språk och marknad",
        country: "Välj land",
        terms: "Villkor",
        rightOfReturn: "dagars returrätt",
        currency: "Valuta",
        allOrders: "På alla beställningar",
        change: "Byt land",
        sweden: "Sverige",
        international: "Rest of Europe",
        denmark: "Denmark",
        norway: "Norway",
        netherlands: "Netherlands",
        france: "France",
        uk: "United Kingdom",
        homeDelivery: "1-3 dagars leveranstid"
      },
      ambassador: {
        title1: "Våra idrottare",
        title2: "Organisationer vi stöttar",
        link2: "Olympiska kommitén",
        link3: "Organisationer"
      },
      mobileMenu: {
        products: "Produkter",
        about: "Om",
        follow: "Följ oss",
        support: "Support",
        menu: "Meny",
        more: "Mer"
      },
      miniCart: {
        youCart: "Din varukorg",
        empty: "Din varukorg är tom",
        emptyCart: "Tom varukorg",
        continueShopping: "Fortsätt shoppa",
        shipping: "Leverans",
        paySafe: "Betala Säkert med",
        and: "och",
        continue: "Gå vidare till kassan",
        more: "Något mer",
        subTotal: "Subtotal",
        payment1: "klarna",
        payment2: "swish",
        free: "Gratis",
        compatible: "Passar med din order!",
        quickAdd: "Tillagd i varukorgen"
      },
      shop: {
        title1: "Bästsäljare",
        title2: "Massage",
        title3: "Träning",
        title4: "Tillbehör",
        title5: "Yoga",
        title6: "Bundles",
        title7: "Deals",
        title8: "Reuse",
        title9: "Events",
        title10: "Rödljusterapi",
      },
      slug: {
        product: "produkt",
        blog: "blogg",
        compare: "jamforelse",
        category: "kategori",
        ourStory: "om-oss",
        massageGuns: "massagepistoler",
        januari: "Januarirea",
        winter: "olympic deals",
        spring: "Vårdeals",
        easter: "Påskdeals",
        title1: "bestsellers",
        title2: "massage",
        title3: "traning",
        title4: "tillbehor",
        title5: "yoga",
        title6: "bundles",
      },
      faq: {
        button: "Läs alla frågor och svar",
        link: "https://support.flowlifesweden.com/hc/sv"
      },
      productInfo: {
        home: "Hem",
        readMore: "Läs mer",
        buyNow: "Köp nu",
        preOrder: "Förbeställ",
        bundleInclude: "Ingår",
        newPrice: "Nytt pris",
        exVat: "exkl. moms",
        bestTest: "Bäst i test",
        oos: "Slutsåld",
        inStock: "I lager",
        lowStock: "Få i lager",
      },
      productTabs: {
        experience: "Köpupplevelse",
        desc: "Beskrivning",
        info: "Teknisk information",
        box: "Vad ingår i paketet?",
        instructions: "Instruktioner",
        faq: "Vanliga frågor och svar"
      },
      productCard: {
        addToCart: "Lägg i varukorgen",
        readMore: "Läs mer om produkten",
        setSize: "Välj storlek",
        setColor: "Välj färg",
        bestseller: "Bästsäljare",
      },
      compare: {
        anchorLink: "Till testet",
        button: "Se hela jämförelsen",
        headLine: "Jämför våra Massagepistoler",
        grade: "Reviews",
        battery: "Batteri",
        batteryLife: "Batteri-liv",
        loadTime: "Laddningstid",
        batteryType: "Typ av batteri",
        performance: "Prestanda",
        stroke: "Slaglängd",
        beats: "Slag per minut",
        motor: "Motor",
        noise: "Ljudnivå",
        pressure: "Maximalt tryck",
        spec: "Specifikationer",
        weight: "Vikt",
        size: "Väskans Storlek",
        dimensions: "Mått",
        bag: "Väska ingår",
        charger: "Laddare",
        nozzle: "Antal Munstycken"
      },
      megaNav: {
        dontMiss: "Missa inte",
        allProducts: "Visa alla produkter"
      },
      marquee: {
        days: "dagar",
        free: "Fri",
        shipping: "Frakt över 500 SEK",
        always: "Alltid",
        freePlural: "Fria",
        satisfaction: "Nöjdkundgaranti",
        returns: "Returer",
        guarantee: "års garanti",
        deals: "CHRISTMAS DEALS",
        fest: "Äntligen måndag!",
        bonanza: "BLACK Week BONANZA",
        now: "PASSA PÅ",
        bf: "MERRY CHRISTMASSAGE",
        find: "LET IT FLOW",
        best: "Fortsatt pangpris",
        cm: "MERRY CHRISTMASSAGE",
        last: "Förlängd rea",
        christmas: "Julklappsgaranti",
        christmas2: "Köp & prova produkten till 3 April",
        merry: "God Jul",
        allWeek: "Julafton hela veckan",
        middle: "Mellandagsrea",
        really: "Klapparna du egentligen ville ha",
        middleDeals: "Mellandagsrea",
        newYear: "GOTT NYTT FLOW",
        janSale: "REA",
        company: "Företagserbjudanden"
      },
      reviews: {
        reviews: "Recensioner",
        seeReviews: "Se alla våra recensioner",
        users: "Recensioner från användare för"
      },
      voucher: {
        success: "Din rabattkod tillämpades",
        error: "Något gick fel...",
        removed: "Din rabattkod togs bort"
      },
      widgets: {
        topics: "Utforska ämnen",
        subscribe: {
          title: "Prenumerera",
          description: "Följ oss på sociala medier för inspiration, tips och tävlingar",
          label: "Skriv upp mig",
          typeform: "HcIjeu7Q"
        },
        followus: "Följ oss"
      },
      footer: {
        follow: "Follow",
        service: "Service",
        info: "Info",
        column1: {
          title: "Prenumerera",
        },
        column2: {
          title: "Få hjälp"
        },
        column3: {
          title: "Information"
        }
      },
      vip: {
        input: "Skriv in din e-mailadress...",
        button: "Registrera",
        title: "Black Week Early Access",
        subtitle: "Signa upp och få exklusiv förtur till Black Week",
      },
      tracking: {
        search: "Spåra order",
        placeholder: "Ordernummer",
        headline: "Spåra din order",
        subtitle: "Fyll i formuläret för att spåra din order",
        content: "Donec posuere vulputate arcu aenean posuere tortor sed cursus feugiat.",
        back: "Gör om sökningen"
      },
      returns: {
        register: "Registrera Retur/Reklamation"
      },
      header: {
        assitance: "Assistance",
        assitanceLink: "https://support.flowlifesweden.com/hc/sv",
      },
      search: {
        shopAll: "Shop all",
        allFilters: "Alla filter",
        filter: "Filtrera",
        clear: "Rensa filter",
        bodyPart: "Kroppsdel",
        misc: "Misc",
        showResults: "Visa resultat",
        price: "Pris",
        search: "Sök",
        popularSearches: "Populära sökningar",
        suggestions: "Förslag",
        close: "Stäng",
        pillow: "Massagekudde",
        pillowSlug: "massagekudde",
        gun: "Massagepistol",
        gunSlug: "massagepistoler",
        feet: "Fotmassage",
        feetSlug: "fotmassage-maskin",
        pression: "Tryckterapi",
        pressionSlug: "flowpression-produkter",
        panels: "Rödljusterapi",
        panelsSlug: "rodljusterapi",
        tens: "TENS",
        tensSlug: "tens",
      }
    }
  },
  dk: {
    translation: {
      langSwitch: {
        se: "Svensk / SEK",
        dk: "Dansk / DKK",
        eu: "Engelsk / EUR",
        no: "Norsk / NOK",
        nl: "Netherland / EUR",
        fr: "France / EUR",
        uk: "Engelsk / GBP",
        changeCountry: "Skift land",
        terms: "Vilkår",
        chooseCountry: "Vælg land",
        freeDelivery: "Altid gratis levering",
        freeDeliveryText: "På alle ordrer",
        freeDeliveryTime: "1-5 dage med hjemmelevering",
        return: "Retur",
        returnText: "30 dages returret",
        currencyText: "Betalingsmiddel",
        currency: "DKK"
      },
      cookie: {
        text: "For at give dig den bedste brugeroplevelse bruger vi Cookies. Få mere at vide om Cookies i vores",
        linkText: "Handelsbetingelser",
        link: "handelsbetingelser"
      },
      thankYou: {
        thanks: "Tusind tak",
        placed: "Vi har modtaget din ordre",
        receipt: "Din kvittering vil blive sendt til",
        info: "Din information",
        orderNumber: "Dit ordrenummer er",
        loading: "laddar",
        goBack: "Tilbage til"
      },
      checkout: {
        checkout: "Kassen",
        orderSum: "Ordresammendrag",
        coupon: "Har du en rabatkode",
        addCoupon: "Tilføj det her",
        apply: "Brug",
        yourCoupon: "Tilføj rabatkode",
        discount: "Rabat",
        total: "Total",
        priceBeforeDiscount: "Pris",
        remove: "Fjerne",
        edit: "Redigere",
        email: "E-mail",
        yourEmail: "Din e-mail-adresse",
        name: "Navn",
        firstName: "Fornavn",
        lastName: "Efternavn",
        address: "Adresse",
        street: "Gade og husnummer",
        CO: "C/O",
        zip: "Postnummer",
        city: "By",
        country: "Land",
        phone: "Telefon",
        phoneNumber: "Dit telefonnummer",
        save: "Gem og fortsæt",
        delivery: "Vælg leveringsmetode",
        marquee1: "Julegavesgaranti - KØB & PRØVE PRODUKTEN TIL 3 APRIL",
        marquee2: "Altid fri fragt & fri retur",
        marquee3: "Altid 2 års garanti",
        marquee4: "julegavegarant",
        tax: "Moms",
        paymentMethod: "Betalingsmetode",
        maintenance: "Flowlife gennemgår planlagt vedligeholdelse. Levering sendes uge 40"
      },
      member: {
        female: "Female",
        male: "Male",
        other: "Other",
        wontSay: "Don't want to say",
        email: "Email",
        emailInput: "Your email address",
        phone: "Phone",
        phoneInput: "Your phone number",
        birthday: "Birthday",
        gender: "Gender",
        ref: "How did you learn about Flowlife?",
        subject: "What segment are you interested in?",
        accept1: "I agree with the ",
        accept2: "terms and conditions",
        choose: "Choose",
        button: "To the deals!",
        day: "Day",
        month: "Month",
        year: "Year",
        climbing: "Climbing",
        crossfit: "Crossfit",
        ski: "Skiing",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Hiking",
        padel: "Padel",
        cycling: "Cycling",
        running: "Running",
      },
      blog: {
        featured: "Udvalgte nyheder",
        latest: "De seneste nyheder",
        topStories: "Mest læste artikler",
        loadMore: "Læs mere",
        noResults: "Ikke flere resultater",
        products: "Produkter i dette indlæg"
      },
      switcher: {
        market: "Vælg sprog og marked",
        country: "Vælg land",
        terms: "Vilkår",
        rightOfReturn: "dages returret",
        currency: "Betalingsmiddel",
        allOrders: "På alle ordrer",
        change: "Skifte land",
        sweden: "Sverige",
        international: "EU",
        denmark: "Danmark",
        norway: "Norge",
        netherlands: "Netherlands",
        france: "France",
        uk: "United Kingdom",
        homeDelivery: "2-5 dage med hjemmelevering"
      },
      ambassador: {
        title1: "Vores atleter",
        title2: "Organisationer, vi støtter",
        link2: "Den olympiske komité",
        link3: "Organisationer"
      },
      mobileMenu: {
        products: "Produkter",
        about: "Om",
        follow: "Følg os",
        support: "Support",
        menu: "Menu",
        more: "Mere"
      },
      miniCart: {
        youCart: "Din indkøbskurv",
        empty: "Din vogn er tom",
        emptyCart: "Tom vogn",
        continueShopping: "Fortsætte med at handle",
        shipping: "Levering",
        paySafe: "Betal sikkert med",
        and: "og",
        continue: "Gå til kassen",
        more: "Noget mere",
        subTotal: "Subtotal",
        payment1: "mobilePay",
        payment2: "mvisa",
        free: "Gratis",
        compatible: "Passer til din ordre!",
        quickAdd: "Added to cart"
      },
      shop: {
        title1: "Bedst sælgende",
        title2: "Massage",
        title3: "Træning",
        title4: "Tilbehør",
        title5: "Yoga",
        title6: "Bundles",
        title7: "Deals",
        title8: "Reuse",
        title9: "Events",
        title10: "Rodt lysterapi",
      },
      slug: {
        product: "produkt",
        blog: "blog",
        compare: "sammenligning",
        category: "kategori",
        ourStory: "om-os",
        massageGuns: "massagepistoler",
        januari: "Januar Deals",
        winter: "winter deals",
        spring: "Forårstilbud",
        easter: "Påske tilbud",
        title1: "bestsellers",
        title2: "massage",
        title3: "traening",
        title4: "tilbehør",
        title5: "yoga",
        title6: "bundles",
      },
      faq: {
        button: "Alle spørgsmål og besvar oplysninger",
        link: "https://support.flowlifesweden.com/hc/da-dk"
      },
      productInfo: {
        home: "Hjem",
        readMore: "Læs mere",
        buyNow: "Køb",
        preOrder: "Forudbestil",
        bundleInclude: "hvad er inkluderet",
        newPrice: "Ny pris",
        exVat: "eksk. moms",
        bestTest: "Bedst i test",
        oos: "Udsolgt",
        inStock: "På lager",
        lowStock: "Lavt lager",
      },
      productTabs: {
        experience: "Shopping oplevelse",
        desc: "Beskrivelse",
        info: "Teknisk information",
        box: "What's in the box?",
        instructions: "Instruktioner",
        faq: "FAQ"

      },
      productCard: {
        addToCart: "Tilføj til kurv",
        readMore: "Læs mere om produktet",
        setSize: "Vælg størrelse",
        setColor: "Vælg farve",
        bestseller: "Bestseller",
      },
      compare: {
        anchorLink: "Til testen",
        button: "Se hele testen",
        headLine: "Sammenlign vores massagepistoler",
        grade: "Mening",
        battery: "Batteri",
        batteryLife: "Batteri liv",
        loadTime: "Lade tid",
        batteryType: "Type batteri",
        performance: "Ydeevne",
        stroke: "Slaglængde",
        beats: "Slag i minuttet",
        motor: "Motor",
        noise: "Støjniveau",
        pressure: "Maksimalt tryk",
        spec: "Specifikationer",
        weight: "Vægt",
        size: "Case size",
        dimensions: "Måle",
        bag: "Taske medfølger",
        charger: "Oplader",
        nozzle: "Antal dyser"
      },
      megaNav: {
        dontMiss: "Gå ikke glip af",
        allProducts: "Vis alle produkter"
      },
      marquee: {
        days: "dages",
        free: "Gratis",
        shipping: "Forsendelse",
        always: "Altid",
        freePlural: "Gratis",
        satisfaction: "Tilfreds kundegaranti",
        returns: "Retur",
        guarantee: "års garanti",
        deals: "CHRISTMAS DEALS",
        fest: "Endelig mandag!",
        bonanza: "BLACK WEEK BONANZA",
        now: "PAS PÅ",
        bf: "MERRY CHRISTMASSAGE",
        find: "LET IT FLOW",
        best: "Stadig super deals",
        cm: "CYBER MONDAY SLUTTER MANDAG DEN 29/11 23.59",
        last: "Udvidet salg",
        christmas: "Julegavesgaranti",
        christmas2: "Køb & prøve produkten til 3. April",
        merry: "GLÆDELIG JUL",
        allWeek: "Juleaften hele ugen",
        middle: "Efter juleudsalg",
        really: "De julegaver du virkelig ønskede dig",
        middleDeals: "Juleudsalg",
        newYear: "Godt nytflow",
        janSale: "SALG",
        company: "Erhvervstilbud"
      },
      reviews: {
        reviews: "Anmedelser",
        seeReviews: "Se alle vores anmedelser",
        users: "Anmeldelser fra brugare til"
      },
      voucher: {
        success: "Din rabatkode blev anvendt",
        error: "Noget gik galt...",
        removed: "Din rabatkode er blevet fjernet"
      },
      widgets: {
        topics: "Udforsk emner",
        subscribe: {
          title: "Abonner",
          description: "Det er bedre som Flow -medlem. Få første og eksklusive adgang til de nyeste stilarter og innovation",
          label: "Tilmeld mig",
          typeform: "HuaSRd46"
        },
        followus: "Følg os"
      },
      footer: {
        follow: "Follow",
        service: "Service",
        info: "Info",
        column1: {
          title: "Abonner",
        },
        column2: {
          title: "Få hjælp"
        },
        column3: {
          title: "Information"
        }
      },
      vip: {
        input: "Din Email adresse...",
        button: "Tilmeld",
        title: "Black Week Tidlig Adang",
        subtitle: "Tilmelde dig for at få tidlig adgang for Black Week",
      },
      tracking: {
        search: "Track order",
        placeholder: "Order number",
        headline: "Track your order",
        subtitle: "Enter you order number to track your order",
        content: "Donec posuere vulputate arcu aenean posuere tortor sed cursus feugiat.",
        back: "Search again"
      },
      returns: {
        register: "Register return"
      },
      header: {
        assitance: "Assistance",
        assitanceLink: "https://support.flowlifesweden.com/hc/da-dk",
      },
      search: {
        shopAll: "Shop all",
        allFilters: "All filters",
        filter: "Filter",
        clear: "Clear filters",
        bodyPart: "Body part",
        misc: "Misc",
        showResults: "Show results",
        price: "Price",
        search: "Search",
        popularSearches: "Popular searches",
        suggestions: "Suggestions",
        close: "Close",
        pillow: "Massagepude",
        pillowSlug: "massagepude",
        gun: "Massagepistoler",
        gunSlug: "massagepistoler",
        feet: "Fodmassage",
        feetSlug: "fodmassageapparat",
        pression: "Trykterapi",
        pressionSlug: "flowpression-produkter",
        panels: "Rødt lysterapi",
        panelsSlug: "rodt-lysterapi",
        tens: "TENS",
        tensSlug: "tens",
      }
    }
  },
  no: {
    translation: {
      langSwitch: {
        se: "Sverige / SEK",
        dk: "Danmark / DKK",
        eu: "Resten av Europa / EUR",
        no: "Norge / NOK",
        nl: "Nederland / EUR",
        fr: "Frankrike / EUR",
        uk: "Storbritannia / GBP",
        changeCountry: "Bytt land",
        terms: "Vilkår",
        chooseCountry: "Velg land",
        freeDelivery: "Alltid gratis levering",
        freeDeliveryText: "På alle bestillinger",
        freeDeliveryTime: "1–7 dager hjemlevering",
        return: "Retur",
        returnText: "",
        currencyText: "Valuta",
        currency: "NOK"
      },
      cookie: {
        text: "For å gi deg den beste brukeropplevelsen bruker vi informasjonskapsler. Les mer om informasjonskapsler via vår",
        linkText: "Personvernerklæring",
        link: "vilkår"
      },
      thankYou: {
        thanks: "Takk",
        placed: "Bestillingen din er lagt inn",
        receipt: "Kvitteringen vil bli sendt til",
        info: "Din informasjon",
        orderNumber: "Ordrenummeret ditt er",
        loading: "laster",
        goBack: "Gå tilbake til"
      },
      checkout: {
        checkout: "Til kassen",
        orderSum: "Din bestilling",
        coupon: "Har du en rabattkode",
        addCoupon: "Legg den til her",
        apply: "Bruk",
        yourCoupon: "Din rabattkode",
        discount: "Rabatt",
        total: "Totalt",
        priceBeforeDiscount: "Delsum",
        remove: "Fjern",
        edit: "Rediger",
        change: "Rediger",
        email: "E-post",
        yourEmail: "Din e-postadresse",
        name: "Navn",
        firstName: "Fornavn",
        lastName: "Etternavn",
        address: "Adresse",
        street: "Gate og husnummer",
        CO: "C/O",
        zip: "Postnummer",
        city: "By",
        country: "Land",
        states: "Fylke",
        phone: "Telefon",
        phoneNumber: "Ditt telefonnummer",
        save: "Lagre og fortsett",
        delivery: "Velg fraktmetode",
        marquee1: "Julegavegaranti – kjøp med åpent kjøp til 3. april",
        marquee2: "Gratis frakt og gratis retur",
        marquee3: "2 års garanti",
        marquee4: "Vellykket julegavegaranti",
        tax: "Avgift",
        paymentMethod: "Betalingsmetode",
        maintenance: "Flowlife gjennomfører planlagt vedlikehold. Leveranser sendes i uke 40"
      },
      member: {
        female: "Kvinne",
        male: "Mann",
        other: "Annet",
        wontSay: "Vil ikke si",
        email: "E-post",
        emailInput: "Din e-postadresse",
        phone: "Telefon",
        phoneInput: "Ditt telefonnummer",
        birthday: "Fødselsdag",
        gender: "Kjønn",
        ref: "Hvordan hørte du om Flowlife?",
        subject: "Hvilket segment er du interessert i?",
        accept1: "Jeg godtar ",
        accept2: "vilkår og betingelser",
        choose: "Velg",
        button: "Til tilbudene!",
        day: "Dag",
        month: "Måned",
        year: "År",
        climbing: "Klatring",
        crossfit: "Crossfit",
        ski: "Ski",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Fottur",
        padel: "Padel",
        cycling: "Sykling",
        running: "Løping"
      },
      blog: {
        featured: "Utvalgt",
        latest: "Siste nytt",
        topStories: "Toppnyheter",
        loadMore: "Last inn mer",
        noResults: "Ingen flere resultater",
        products: "Produkter i denne artikkelen"
      },
      switcher: {
        market: "Velg språk og marked",
        country: "Velg land",
        terms: "Vilkår",
        rightOfReturn: "–dagers pengene tilbake-garanti",
        currency: "Valuta",
        allOrders: "På alle bestillinger",
        change: "Bytt land",
        sweden: "Sverige",
        international: "Resten av Europa",
        denmark: "Danmark",
        norway: "Norge",
        netherlands: "Nederland",
        france: "Frankrike",
        uk: "Storbritannia",
        homeDelivery: "1–3 dager levering"
      },
      ambassador: {
        title1: "Våre utøvere",
        title2: "Organisasjoner vi støtter",
        link2: "Den olympiske komité",
        link3: "Organisasjoner"
      },
      mobileMenu: {
        products: "Produkter",
        about: "Om oss",
        follow: "Følg oss",
        support: "Support",
        menu: "Meny",
        more: "Mer"
      },
      miniCart: {
        youCart: "Handlekurven din",
        empty: "Handlekurven din er tom",
        emptyCart: "Tøm handlekurv",
        continueShopping: "Fortsett å handle",
        shipping: "Frakt",
        paySafe: "Betal trygt med",
        and: "og",
        continue: "Gå til kassen",
        more: "Noe mer?",
        subTotal: "Delsum",
        payment1: "payPal",
        payment2: "mvisa",
        free: "Gratis",
        compatible: "Kompatibel med bestillingen din",
        quickAdd: "Lagt til i handlekurv"
      },
      shop: {
        title1: "Bestselgere",
        title2: "Restitusjon",
        title3: "Ytelse",
        title4: "Tilbehør",
        title5: "Yoga",
        title6: "Pakker",
        title7: "Tilbud",
        title8: "Gjenbruk",
        title9: "Arrangementer",
        title10: "Rødt lys-terapi"
      },
      slug: {
        product: "produkt",
        blog: "blogg",
        compare: "sammenlign",
        category: "kategori",
        ourStory: "vår historie",
        massageGuns: "massasjepistoler",
        januari: "Januarsalg",
        winter: "vintertilbud",
        spring: "Vårkampanje",
        easter: "Påskekampanje",
        title1: "bestselger",
        title2: "massasje",
        title3: "trening",
        title4: "tilbehør",
        title5: "yoga",
        title6: "pakker"
      },
      faq: {
        button: "Alle spørsmål og svar",
        link: "https://support.flowlifesweden.com/hc/en-us"
      },
      productInfo: {
        home: "Hjem",
        readMore: "Les mer",
        buyNow: "Kjøp nå",
        preOrder: "Forhåndsbestill",
        bundleInclude: "Inkludert",
        newPrice: "Ny pris",
        exVat: "Ekskl. mva",
        bestTest: "Best i test",
        oos: "Utsolgt",
        inStock: "På lager",
        lowStock: "Begrenset lager"
      },
      productTabs: {
        experience: "Handleopplevelse",
        desc: "Beskrivelse",
        info: "Teknisk informasjon",
        box: "Hva er i esken?",
        instructions: "Instruksjoner",
        faq: "FAQ"
      },
      productCard: {
        addToCart: "Legg i handlekurv",
        readMore: "Les mer om produktet",
        setSize: "Velg størrelse",
        setColor: "Velg farge",
        bestseller: "Bestselger"
      },
      compare: {
        anchorLink: "Til testen",
        button: "Til testen",
        headLine: "Sammenlign våre massasjepistoler",
        grade: "Karakter",
        battery: "Batteri",
        batteryLife: "Batteritid",
        loadTime: "Ladetid",
        batteryType: "Batteritype",
        performance: "Ytelse",
        stroke: "Slaglengde",
        beats: "Slag per minutt",
        motor: "Motor",
        noise: "Støynivå",
        pressure: "Maksimalt trykk",
        spec: "Spesifikasjoner",
        weight: "Vekt",
        size: "Størrelse på etui",
        dimensions: "Mål",
        bag: "Veske inkludert",
        charger: "Lader",
        nozzle: "Antall munnstykker"
      },
      megaNav: {
        dontMiss: "Ikke gå glipp av",
        allProducts: "Vis alle produkter"
      },
      marquee: {
        days: "dager",
        free: "Gratis",
        shipping: "Frakt",
        always: "Alltid",
        freePlural: "Gratis",
        satisfaction: "Fornøyd kunde-garanti",
        returns: "Retur",
        guarantee: "års garanti",
        deals: "JULETILBUD",
        fest: "Glad mandag",
        bonanza: "BLACK WEEK BONANZA",
        now: "Kjøp nå",
        bf: "GOD JULEMASSASJE",
        find: "LET IT FLOW",
        best: "Supertilbud",
        cm: "CYBER MONDAY SLUTTER MANDAG 29/11 KL. 23.59",
        last: "Forlenget salg",
        christmas: "Julegavegaranti",
        christmas2: "Kjøp med åpent kjøp til 3. april",
        merry: "God jul",
        allWeek: "Jul hele dagen, hver dag",
        middle: "Julesalg",
        really: "Gavene du virkelig ønsket deg",
        middleDeals: "Romjulssalg",
        newYear: "Godt nytt Flow",
        janSale: "SALG",
        company: "Bedriftstilbud"
      },
      reviews: {
        reviews: "Anmeldelser",
        seeReviews: "Se alle anmeldelser",
        users: "Brukeranmeldelser for"
      },
      voucher: {
        success: "Rabattkoden din er brukt",
        error: "Noe gikk galt...",
        removed: "Rabattkoden din er fjernet"
      },
      widgets: {
        topics: "Utforsk temaer",
        subscribe: {
          title: "Abonner",
          description: "Alt er bedre som Flow-medlem. Få eksklusiv tilgang til de nyeste stilene og innovasjonene først",
          label: "Meld meg på",
          typeform: "SFqzvXJY"
        },
        followus: "Følg oss"
      },
      footer: {
        follow: "Følg",
        service: "Kundeservice",
        info: "Informasjon",
        column1: {
          title: "Abonner"
        },
        column2: {
          title: "Få hjelp"
        },
        column3: {
          title: "Informasjon"
        }
      },
      vip: {
        input: "Din e-postadresse...",
        button: "Registrer deg",
        title: "Early Access til Black Week",
        subtitle: "Registrer deg for å få tidlig tilgang til Black Week"
      },
      tracking: {
        search: "Spor ordre",
        placeholder: "Ordrenummer",
        headline: "Spor din ordre",
        subtitle: "Skriv inn ordrenummeret for å spore din bestilling",
        content: "Din ordre er under behandling.",
        back: "Søk igjen"
      },
      returns: {
        register: "Registrer retur"
      },
      header: {
        assitance: "Hjelp",
        assitanceLink: "https://support.flowlifesweden.com/hc/en-us"
      },
      search: {
        shopAll: "Se alle",
        allFilters: "Alle filtre",
        filter: "Filtrer",
        clear: "Fjern filtre",
        bodyPart: "Kroppsdel",
        misc: "Annet",
        showResults: "Vis resultater",
        price: "Pris",
        search: "Søk",
        popularSearches: "Populære søk",
        suggestions: "Forslag",
        close: "Lukk",
        pillow: "Massasjepute",
        pillowSlug: "massasjepute",
        gun: "Massasjepistoler",
        gunSlug: "massasjepistoler",
        feet: "Fotmassasje",
        feetSlug: "fotmassasjeapparat",
        pression: "Komprimeringsterapi",
        pressionSlug: "flowpression-produkter",
        panels: "Rødt lys-terapi",
        panelsSlug: "rodt-lys-terapi",
        tens: "TENS",
        tensSlug: "tens"
      }
    }
  },
  nl: {
    translation: {
      langSwitch: {
        se: "Zweden / SEK",
        dk: "Denemarken / DKK",
        eu: "Rest van Europa / EUR",
        no: "Noorwegen / NOK",
        nl: "Nederland / EUR",
        fr: "Frankrijk / EUR",
        uk: "Verenigd Koninkrijk / GBP",
        changeCountry: "Land wijzigen",
        terms: "Voorwaarden",
        chooseCountry: "Kies land",
        freeDelivery: "Altijd gratis levering",
        freeDeliveryText: "Op alle bestellingen",
        freeDeliveryTime: "2–5 dagen levering aan huis",
        return: "Retourneren",
        returnText: "",
        currencyText: "Valuta",
        currency: "EUR"
      },
      cookie: {
        text: "Om je de beste gebruikerservaring te bieden, gebruiken we cookies. Lees meer over cookies via onze",
        linkText: "Privacybeleid",
        link: "voorwaarden"
      },
      thankYou: {
        thanks: "Bedankt",
        placed: "Je bestelling is geplaatst",
        receipt: "Je ontvangstbewijs wordt verzonden naar",
        info: "Jouw informatie",
        orderNumber: "Je ordernummer is",
        loading: "laden",
        goBack: "Ga terug naar"
      },
      checkout: {
        checkout: "Afrekenen",
        orderSum: "Je bestelling",
        coupon: "Heb je een kortingscode",
        addCoupon: "Voer deze hier in",
        apply: "Toepassen",
        yourCoupon: "Jouw kortingscode",
        discount: "Korting",
        total: "Totaal",
        priceBeforeDiscount: "Subtotaal",
        remove: "Verwijderen",
        edit: "Bewerken",
        change: "Bewerken",
        email: "E-mail",
        yourEmail: "Jouw e-mailadres",
        name: "Naam",
        firstName: "Voornaam",
        lastName: "Achternaam",
        address: "Adres",
        street: "Straat en huisnummer",
        CO: "T.a.v.",
        zip: "Postcode",
        city: "Stad",
        country: "Land",
        states: "Provincie",
        phone: "Telefoon",
        phoneNumber: "Jouw telefoonnummer",
        save: "Opslaan & Doorgaan",
        delivery: "Kies verzendmethode",
        marquee1: "Cadeaubongarantie – aankoop op zicht tot 3 april",
        marquee2: "Gratis verzending & gratis retourneren",
        marquee3: "2 jaar garantie",
        marquee4: "Succesvolle cadeaubongarantie",
        tax: "Belasting",
        paymentMethod: "Betaalmethode",
        maintenance: "Flowlife voert gepland onderhoud uit. Leveringen worden verstuurd in week 40"
      },
      member: {
        female: "Vrouw",
        male: "Man",
        other: "Anders",
        wontSay: "Wil niet zeggen",
        email: "E-mail",
        emailInput: "Jouw e-mailadres",
        phone: "Telefoon",
        phoneInput: "Jouw telefoonnummer",
        birthday: "Verjaardag",
        gender: "Geslacht",
        ref: "Hoe heb je over Flowlife gehoord?",
        subject: "In welk segment ben je geïnteresseerd?",
        accept1: "Ik ga akkoord met de ",
        accept2: "algemene voorwaarden",
        choose: "Kiezen",
        button: "Naar de aanbiedingen!",
        day: "Dag",
        month: "Maand",
        year: "Jaar",
        climbing: "Klimmen",
        crossfit: "Crossfit",
        ski: "Skiën",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Wandelen",
        padel: "Padel",
        cycling: "Fietsen",
        running: "Hardlopen"
      },
      blog: {
        featured: "Uitgelicht",
        latest: "Laatste nieuws",
        topStories: "Topverhalen",
        loadMore: "Meer laden",
        noResults: "Geen verdere resultaten",
        products: "Producten in dit artikel"
      },
      switcher: {
        market: "Kies taal en markt",
        country: "Kies land",
        terms: "Voorwaarden",
        rightOfReturn: "–dagen geld-terug-garantie",
        currency: "Valuta",
        allOrders: "Op alle bestellingen",
        change: "Land wijzigen",
        sweden: "Zweden",
        international: "Rest van Europa",
        denmark: "Denemarken",
        norway: "Noorwegen",
        netherlands: "Nederland",
        france: "Frankrijk",
        uk: "Verenigd Koninkrijk",
        homeDelivery: "1–3 dagen levering"
      },
      ambassador: {
        title1: "Onze atleten",
        title2: "Organisaties die wij steunen",
        link2: "Het Olympisch Comité",
        link3: "Organisaties"
      },
      mobileMenu: {
        products: "Producten",
        about: "Over ons",
        follow: "Volg ons",
        support: "Ondersteuning",
        menu: "Menu",
        more: "Meer"
      },
      miniCart: {
        youCart: "Jouw winkelwagen",
        empty: "Je winkelwagen is leeg",
        emptyCart: "Winkelwagen legen",
        continueShopping: "Doorgaan met winkelen",
        shipping: "Verzending",
        paySafe: "Veilig betalen met",
        and: "en",
        continue: "Doorgaan naar afrekenen",
        more: "Nog iets?",
        subTotal: "Subtotaal",
        payment1: "PayPal",
        payment2: "mVisa",
        free: "Gratis",
        compatible: "Compatibel met je bestelling",
        quickAdd: "Toegevoegd aan winkelwagen"
      },
      shop: {
        title1: "Bestsellers",
        title2: "Herstel",
        title3: "Prestatie",
        title4: "Accessoires",
        title5: "Yoga",
        title6: "Pakketten",
        title7: "Aanbiedingen",
        title8: "Hergebruik",
        title9: "Evenementen",
        title10: "Roodlichttherapie"
      },
      slug: {
        product: "product",
        blog: "blog",
        compare: "vergelijken",
        category: "categorie",
        ourStory: "ons verhaal",
        massageGuns: "massagepistolen",
        januari: "Januari-uitverkoop",
        winter: "winteraanbiedingen",
        spring: "Voorjaarscampagne",
        easter: "Paascampagne",
        title1: "bestseller",
        title2: "massage",
        title3: "training",
        title4: "accessoires",
        title5: "yoga",
        title6: "pakketten"
      },
      faq: {
        button: "Alle vragen en antwoorden",
        link: "https://support.flowlifesweden.com/hc/en-us"
      },
      productInfo: {
        home: "Home",
        readMore: "Lees meer",
        buyNow: "Koop nu",
        preOrder: "Pre-order",
        bundleInclude: "Inbegrepen",
        newPrice: "Nieuwe prijs",
        exVat: "Excl. btw",
        bestTest: "Beste uit de test",
        oos: "Niet op voorraad",
        inStock: "Op voorraad",
        lowStock: "Beperkte voorraad"
      },
      productTabs: {
        experience: "Winkelervaring",
        desc: "Beschrijving",
        info: "Technische informatie",
        box: "Wat zit er in de doos?",
        instructions: "Instructies",
        faq: "FAQ"
      },
      productCard: {
        addToCart: "In winkelwagen",
        readMore: "Meer over het product",
        setSize: "Selecteer maat",
        setColor: "Selecteer kleur",
        bestseller: "Bestseller"
      },
      compare: {
        anchorLink: "Naar de test",
        button: "Naar de test",
        headLine: "Vergelijk onze massagepistolen",
        grade: "Beoordeling",
        battery: "Batterij",
        batteryLife: "Batterijduur",
        loadTime: "Oplaadtijd",
        batteryType: "Batterijtype",
        performance: "Prestaties",
        stroke: "Slaglengte",
        beats: "Slagen per minuut",
        motor: "Motor",
        noise: "Geluidsniveau",
        pressure: "Maximale druk",
        spec: "Specificaties",
        weight: "Gewicht",
        size: "Etui grootte",
        dimensions: "Afmetingen",
        bag: "Tas inbegrepen",
        charger: "Oplader",
        nozzle: "Aantal opzetstukken"
      },
      megaNav: {
        dontMiss: "Mis het niet",
        allProducts: "Toon alle producten"
      },
      marquee: {
        days: "dagen",
        free: "Gratis",
        shipping: "Verzending",
        always: "Altijd",
        freePlural: "Gratis",
        satisfaction: "Tevredenheid gegarandeerd",
        returns: "Retourneren",
        guarantee: "jaar garantie",
        deals: "KERSTAANBIEDINGEN",
        fest: "Fijne maandag",
        bonanza: "BLACK WEEK BONANZA",
        now: "Koop nu",
        bf: "VROLIJKE KERSTMASSAGE",
        find: "LAAT HET STROMEN",
        best: "Superaanbiedingen",
        cm: "CYBER MONDAY EINDIGT MAANDAG 29/11 OM 23.59",
        last: "Verlengde uitverkoop",
        christmas: "Kerstcadeaugarantie",
        christmas2: "Aankoop op zicht tot 3 april",
        merry: "Vrolijk kerstfeest",
        allWeek: "Elke dag kerst",
        middle: "Kerstuitverkoop",
        really: "De cadeaus die je echt wilde",
        middleDeals: "Na-kerst uitverkoop",
        newYear: "Gelukkig nieuw Flow-jaar",
        janSale: "UITVERKOOP",
        company: "Zakelijke aanbiedingen"
      },
      reviews: {
        reviews: "Beoordelingen",
        seeReviews: "Bekijk alle beoordelingen",
        users: "Gebruikersbeoordelingen voor"
      },
      voucher: {
        success: "Je kortingscode is toegepast",
        error: "Er is iets misgegaan...",
        removed: "Je kortingscode is verwijderd"
      },
      widgets: {
        topics: "Ontdek onderwerpen",
        subscribe: {
          title: "Abonneren",
          description: "Als Flow-lid krijg je als eerste toegang tot de nieuwste stijlen & innovaties",
          label: "Schrijf me in",
          typeform: "SFqzvXJY"
        },
        followus: "Volg ons"
      },
      footer: {
        follow: "Volg",
        service: "Klantenservice",
        info: "Informatie",
        column1: {
          title: "Abonneren"
        },
        column2: {
          title: "Hulp nodig?"
        },
        column3: {
          title: "Informatie"
        }
      },
      vip: {
        input: "Jouw e-mailadres...",
        button: "Aanmelden",
        title: "Vroege toegang tot Black Week",
        subtitle: "Meld je aan voor vroege toegang tot Black Week"
      },
      tracking: {
        search: "Volg bestelling",
        placeholder: "Bestelnummer",
        headline: "Volg je bestelling",
        subtitle: "Vul je bestelnummer in om je bestelling te volgen",
        content: "We verwerken je bestelling.",
        back: "Opnieuw zoeken"
      },
      returns: {
        register: "Retour aanmelden"
      },
      header: {
        assitance: "Hulp",
        assitanceLink: "https://support.flowlifesweden.com/hc/en-us"
      },
      search: {
        shopAll: "Alles bekijken",
        allFilters: "Alle filters",
        filter: "Filter",
        clear: "Filters wissen",
        bodyPart: "Lichaamsdeel",
        misc: "Diversen",
        showResults: "Resultaten tonen",
        price: "Prijs",
        search: "Zoeken",
        popularSearches: "Populaire zoekopdrachten",
        suggestions: "Suggesties",
        close: "Sluiten",
        pillow: "Massagekussen",
        pillowSlug: "massagekussen",
        gun: "Massagepistolen",
        gunSlug: "massagepistolen",
        feet: "Voetmassage",
        feetSlug: "voetmassageapparaat",
        pression: "Compressietherapie",
        pressionSlug: "flowpression-producten",
        panels: "Roodlichttherapie",
        panelsSlug: "rood-licht-therapie",
        tens: "TENS",
        tensSlug: "tens"
      }
    }
  },
  fr: {
    translation: {
      langSwitch: {
        se: "Sweden / SEK",
        dk: "Denmark / DKK",
        eu: "Rest of Europe / EUR",
        no: "Norway / NOK",
        nl: "Netherland / EUR",
        fr: "France / EUR",
        uk: "United Kingdom / GBP",
        changeCountry: "Change country",
        terms: "Terms",
        chooseCountry: "Choose country",
        freeDelivery: "Always free delivery",
        freeDeliveryText: "On all orders",
        freeDeliveryTime: "1-5 days home delivery",
        return: "Returns",
        returnText: "",
        currencyText: "Currency",
        currency: "EUR"
      },
      cookie: {
        text: "To give you the best user experience we are using Cookies. Learn more about Cookies via our",
        linkText: "Privacy Policy",
        link: "conditions"
      },
      thankYou: {
        thanks: "Thank you",
        placed: "Your order has been placed",
        receipt: "Your receipt will be sent to",
        info: "Your information",
        orderNumber: "Your order number is",
        loading: "loading",
        goBack: "Go back to"

      },
      checkout: {
        checkout: "Checkout",
        orderSum: "Your order",
        coupon: "Have a coupon",
        addCoupon: "Apply it here",
        apply: "Apply",
        yourCoupon: "Your coupon",
        discount: "Discount",
        total: "Total",
        priceBeforeDiscount: "Subtotal",
        remove: "Remove",
        edit: "Change",
        change: "Edit",
        email: "E-mail",
        yourEmail: "Your E-mail address",
        name: "Name",
        firstName: "First name",
        lastName: "Last name",
        address: "Address",
        street: "Street and house number",
        CO: "C/O",
        zip: "Zip code",
        city: "City",
        country: "Country",
        states: "Province",
        phone: "Phone",
        phoneNumber: "Your phone number",
        save: "Save & Continue",
        delivery: "Choose Shipping Method",
        marquee1: "Christmas gift guarantee - purchase on approval until april 3",
        marquee2: "Free shipping & Free returns",
        marquee3: "2 years warranty",
        marquee4: "Successful Christmas gift guarantee",
        tax: "Tax",
        paymentMethod: "Payment method",
        maintenance: "Flowlife undergoes scheduled maintenance. Deliveries are sent week 40"
      },
      member: {
        female: "Female",
        male: "Male",
        other: "Other",
        wontSay: "Don't want to say",
        email: "Email",
        emailInput: "Your email address",
        phone: "Phone",
        phoneInput: "Your phone number",
        birthday: "Birthday",
        gender: "Gender",
        ref: "How did you learn about Flowlife?",
        subject: "What segment are you interested in?",
        accept1: "I agree with the ",
        accept2: "terms and conditions",
        choose: "Choose",
        button: "To the deals!",
        day: "Day",
        month: "Month",
        year: "Year",
        climbing: "Climbing",
        crossfit: "Crossfit",
        ski: "Skiing",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Hiking",
        padel: "Padel",
        cycling: "Cycling",
        running: "Running",
      },
      blog: {
        featured: "Featured",
        latest: "Latest news",
        topStories: "Top stories",
        loadMore: "Load more",
        noResults: "No more results",
        products: "Products in this article"
      },
      switcher: {
        market: "Choose language and market",
        country: "Choose Country",
        terms: "Terms",
        rightOfReturn: "-days money-back guarantee",
        currency: "Currency",
        allOrders: "On all orders",
        change: "Change Country",
        sweden: "Sweden",
        international: "Rest of Europe",
        denmark: "Denmark",
        norway: "Norway",
        netherlands: "Netherlands",
        france: "France",
        uk: "United Kingdom",
        homeDelivery: "8-12 days delivery, Only inside the European Union"
      },
      ambassador: {
        title1: "Our athletes",
        title2: "Organizations we support",
        link2: "The Olympic Committee",
        link3: "Organizations"
      },
      mobileMenu: {
        products: "Products",
        about: "About",
        follow: "Follow us",
        support: "Support",
        menu: "Menu",
        more: "More"
      },
      miniCart: {
        youCart: "Your Cart",
        empty: "Your cart is empty",
        emptyCart: "Empty cart",
        continueShopping: "Continue shopping",
        shipping: "Shipping",
        paySafe: "Pay safely with",
        and: "and",
        continue: "Proceed to checkout",
        more: "Anything else",
        subTotal: "Subtotal",
        payment1: "payPal",
        payment2: "mvisa",
        free: "Free",
        compatible: "Compatible with your order",
        quickAdd: "Added to cart"
      },
      shop: {
        title1: "Bestsellers",
        title2: "Recovery",
        title3: "Performance",
        title4: "Accessories",
        title5: "Yoga",
        title6: "Bundles",
        title7: "Deals",
        title8: "Reuse",
        title9: "Events",
        title10: "Red Light Therapy",
      },
      slug: {
        product: "product",
        blog: "blog",
        compare: "compare",
        category: "category",
        ourStory: "our-story",
        massageGuns: "massage-guns",
        januari: "January sale",
        winter: "winter deals",
        spring: "Spring deals",
        easter: "Easter deals",
        title1: "bestsellers",
        title2: "recovery",
        title3: "performance",
        title4: "accessories",
        title5: "yoga",
        title6: "bundles",
      },
      faq: {
        button: "All questions and answers",
        link: "https://support.flowlifesweden.com/hc/en-us"
      },
      productInfo: {
        home: "Home",
        readMore: "Read more",
        buyNow: "Buy now",
        preOrder: "Pre-order",
        bundleInclude: "Included",
        newPrice: "New price",
        exVat: "Excl. VAT",
        bestTest: "Best in test",
        oos: "Out of stock",
        inStock: "In stock",
        lowStock: "Low in stock",
      },
      productTabs: {
        experience: "Shopping experience",
        desc: "Description",
        info: "Technical information",
        box: "What's in the box?",
        instructions: "Instructions",
        faq: "FAQ"
      },
      productCard: {
        addToCart: "Add to cart",
        readMore: "Read more about the product",
        setSize: "Select Size",
        setColor: "Select Color",
        bestseller: "Bestseller",
      },
      compare: {
        anchorLink: "To the test",
        button: "To the test",
        headLine: "Compare our massage guns",
        grade: "Grade",
        battery: "Battery",
        batteryLife: "Battery life",
        loadTime: "Load time",
        batteryType: "Battery type",
        performance: "Performance",
        stroke: "Stroke length",
        beats: "Beats per minute",
        motor: "Motor",
        noise: "Noise level",
        pressure: "Maximum pressure",
        spec: "Specifications",
        weight: "Weight",
        size: "Case size",
        dimensions: "Dimensions",
        bag: "Bag Included",
        charger: "Charger",
        nozzle: "Number of nozzles"
      },
      megaNav: {
        dontMiss: "Don't miss",
        allProducts: "Show all products"
      },
      marquee: {
        days: "days",
        free: "Free",
        shipping: "Shipping",
        always: "Always",
        freePlural: "Free",
        satisfaction: "Customer satisfaction guaranteed",
        returns: "Returns",
        guarantee: "years warranty",
        deals: "CHRISTMAS DEALS",
        fest: "Happy Monday",
        bonanza: "BLACK WEEK BONANZA",
        now: "Buy now",
        bf: "MERRY CHRISTMASSAGE",
        find: "LET IT FLOW",
        best: "Super deals",
        cm: "CYBER MONDAY ENDS ON MONDAY THE 29/11 AT 23.59",
        last: "Extended sale",
        christmas: "Christmas gift guarantee",
        christmas2: "Purchase on approval until April 3",
        merry: "Merry Christmas",
        allWeek: "Christmas all day every day",
        middle: "Christmas sale",
        really: "The gifts you really wanted",
        middleDeals: "After Christmas Sale",
        newYear: "Happy New Flow",
        janSale: "SALE",
        company: "Company offers"
      },
      reviews: {
        reviews: "Reviews",
        seeReviews: "See all reviews",
        users: "Reviews from users for"
      },
      voucher: {
        success: "Your coupon was applied",
        error: "Something went wrong...",
        removed: "Your coupon was removed"
      },
      widgets: {
        topics: "Explore topics",
        subscribe: {
          title: "Subscribe",
          description: "Things are better as a Flow Member. Get first and exclusive access to the newest styles & innovation",
          label: "Sign me up",
          typeform: "SFqzvXJY"
        },
        followus: "Follow Us"
      },
      footer: {
        follow: "Follow",
        service: "Service",
        info: "Info",
        column1: {
          title: "Subscribe",
        },
        column2: {
          title: "Get help"
        },
        column3: {
          title: "Information"
        }
      },
      vip: {
        input: "Your Email address...",
        button: "Sign Up",
        title: "Black Week Early Access",
        subtitle: "Sign up to get early access for Black Week"
      },
      tracking: {
        search: "Track order",
        placeholder: "Order number",
        headline: "Track your order",
        subtitle: "Enter you order number to track your order",
        content: "Donec posuere vulputate arcu aenean posuere tortor sed cursus feugiat.",
        back: "Search again"
      },
      returns: {
        register: "Register return"
      },
      header: {
        assitance: "Assistance",
        assitanceLink: "https://support.flowlifesweden.com/hc/en-us",
      },
      search: {
        shopAll: "Shop all",
        allFilters: "All filters",
        filter: "Filter",
        clear: "Clear filters",
        bodyPart: "Body part",
        misc: "Misc",
        showResults: "Show results",
        price: "Price",
        search: "Search",
        popularSearches: "Popular searches",
        suggestions: "Suggestions",
        close: "Close",
        pillow: "Massage pillow",
        pillowSlug: "massage-pillow",
        gun: "Massage guns",
        gunSlug: "massage-guns",
        feet: "Foot massage",
        feetSlug: "foot-massager",
        pression: "Compression therapy",
        pressionSlug: "flowpression-products",
        panels: "Red light therapy",
        panelsSlug: "red-light-therapy",
        tens: "TENS",
        tensSlug: "tens",
      }
    }
  },
  uk: {
    translation: {
      langSwitch: {
        se: "Sweden / SEK",
        dk: "Denmark / DKK",
        eu: "Rest of Europe / EUR",
        no: "Norway / NOK",
        nl: "Netherland / EUR",
        fr: "France / EUR",
        uk: "United Kingdom / GBP",
        changeCountry: "Change country",
        terms: "Terms",
        chooseCountry: "Choose country",
        freeDelivery: "Always free delivery",
        freeDeliveryText: "On all orders",
        freeDeliveryTime: "1-4 days delivery time",
        return: "Returns",
        returnText: "",
        currencyText: "Currency",
        currency: "GBP"
      },
      cookie: {
        text: "To give you the best user experience we are using Cookies. Learn more about Cookies via our",
        linkText: "Privacy Policy",
        link: "conditions"
      },
      thankYou: {
        thanks: "Thank you",
        placed: "Your order has been placed",
        receipt: "Your receipt will be sent to",
        info: "Your information",
        orderNumber: "Your order number is",
        loading: "loading",
        goBack: "Go back to"

      },
      checkout: {
        checkout: "Checkout",
        orderSum: "Your order",
        coupon: "Have a coupon",
        addCoupon: "Apply it here",
        apply: "Apply",
        yourCoupon: "Your coupon",
        discount: "Discount",
        total: "Total",
        priceBeforeDiscount: "Subtotal",
        remove: "Remove",
        edit: "Change",
        change: "Edit",
        email: "E-mail",
        yourEmail: "Your E-mail address",
        name: "Name",
        firstName: "First name",
        lastName: "Last name",
        address: "Address",
        street: "Street and house number",
        CO: "C/O",
        zip: "Zip code",
        city: "City",
        country: "Country",
        states: "Province",
        phone: "Phone",
        phoneNumber: "Your phone number",
        save: "Save & Continue",
        delivery: "Choose Shipping Method",
        marquee1: "Christmas gift guarantee - purchase on approval until april 3",
        marquee2: "Free shipping & Free returns",
        marquee3: "2 years warranty",
        marquee4: "Successful Christmas gift guarantee",
        tax: "Tax",
        paymentMethod: "Payment method",
        maintenance: "Flowlife undergoes scheduled maintenance. Deliveries are sent week 40"
      },
      member: {
        female: "Female",
        male: "Male",
        other: "Other",
        wontSay: "Don't want to say",
        email: "Email",
        emailInput: "Your email address",
        phone: "Phone",
        phoneInput: "Your phone number",
        birthday: "Birthday",
        gender: "Gender",
        ref: "How did you learn about Flowlife?",
        subject: "What segment are you interested in?",
        accept1: "I agree with the ",
        accept2: "terms and conditions",
        choose: "Choose",
        button: "To the deals!",
        day: "Day",
        month: "Month",
        year: "Year",
        climbing: "Climbing",
        crossfit: "Crossfit",
        ski: "Skiing",
        golf: "Golf",
        tennis: "Tennis",
        hiking: "Hiking",
        padel: "Padel",
        cycling: "Cycling",
        running: "Running",
      },
      blog: {
        featured: "Featured",
        latest: "Latest news",
        topStories: "Top stories",
        loadMore: "Load more",
        noResults: "No more results",
        products: "Products in this article"
      },
      switcher: {
        market: "Choose language and market",
        country: "Choose Country",
        terms: "Terms",
        rightOfReturn: "-days money-back guarantee",
        currency: "Currency",
        allOrders: "On all orders",
        change: "Change Country",
        sweden: "Sweden",
        international: "Rest of Europe",
        denmark: "Denmark",
        norway: "Norway",
        netherlands: "Netherlands",
        france: "France",
        uk: "United Kingdom",
        homeDelivery: "1-4 days delivery time"
      },
      ambassador: {
        title1: "Our athletes",
        title2: "Organizations we support",
        link2: "The Olympic Committee",
        link3: "Organizations"
      },
      mobileMenu: {
        products: "Products",
        about: "About",
        follow: "Follow us",
        support: "Support",
        menu: "Menu",
        more: "More"
      },
      miniCart: {
        youCart: "Your Cart",
        empty: "Your cart is empty",
        emptyCart: "Empty cart",
        continueShopping: "Continue shopping",
        shipping: "Shipping",
        paySafe: "Pay safely with",
        and: "and",
        continue: "Proceed to checkout",
        more: "Anything else",
        subTotal: "Subtotal",
        payment1: "payPal",
        payment2: "mvisa",
        free: "Free",
        compatible: "Compatible with your order",
        quickAdd: "Added to cart"
      },
      shop: {
        title1: "Bestsellers",
        title2: "Recovery",
        title3: "Performance",
        title4: "Accessories",
        title5: "Yoga",
        title6: "Bundles",
        title7: "Deals",
        title8: "Reuse",
        title9: "Events",
        title10: "Red Light Therapy",
      },
      slug: {
        product: "product",
        blog: "blog",
        compare: "compare",
        category: "category",
        ourStory: "our-story",
        massageGuns: "massage-guns",
        januari: "January sale",
        winter: "winter deals",
        spring: "Spring deals",
        easter: "Easter deals",
        title1: "bestsellers",
        title2: "recovery",
        title3: "performance",
        title4: "accessories",
        title5: "yoga",
        title6: "bundles",
      },
      faq: {
        button: "All questions and answers",
        link: "https://support.flowlifesweden.com/hc/en-us"
      },
      productInfo: {
        home: "Home",
        readMore: "Read more",
        buyNow: "Buy now",
        preOrder: "Pre-order",
        bundleInclude: "Included",
        newPrice: "New price",
        exVat: "Excl. VAT",
        bestTest: "Best in test",
        oos: "Out of stock",
        inStock: "In stock",
        lowStock: "Low in stock",
      },
      productTabs: {
        experience: "Shopping experience",
        desc: "Description",
        info: "Technical information",
        box: "What's in the box?",
        instructions: "Instructions",
        faq: "FAQ"
      },
      productCard: {
        addToCart: "Add to cart",
        readMore: "Read more about the product",
        setSize: "Select Size",
        setColor: "Select Color",
        bestseller: "Bestseller",
      },
      compare: {
        anchorLink: "To the test",
        button: "To the test",
        headLine: "Compare our massage guns",
        grade: "Grade",
        battery: "Battery",
        batteryLife: "Battery life",
        loadTime: "Load time",
        batteryType: "Battery type",
        performance: "Performance",
        stroke: "Stroke length",
        beats: "Beats per minute",
        motor: "Motor",
        noise: "Noise level",
        pressure: "Maximum pressure",
        spec: "Specifications",
        weight: "Weight",
        size: "Case size",
        dimensions: "Dimensions",
        bag: "Bag Included",
        charger: "Charger",
        nozzle: "Number of nozzles"
      },
      megaNav: {
        dontMiss: "Don't miss",
        allProducts: "Show all products"
      },
      marquee: {
        days: "days",
        free: "Free",
        shipping: "Shipping",
        always: "Always",
        freePlural: "Free",
        satisfaction: "Customer satisfaction guaranteed",
        returns: "Returns",
        guarantee: "years warranty",
        deals: "CHRISTMAS DEALS",
        fest: "Happy Monday",
        bonanza: "BLACK WEEK BONANZA",
        now: "Buy now",
        bf: "MERRY CHRISTMASSAGE",
        find: "LET IT FLOW",
        best: "Super deals",
        cm: "CYBER MONDAY ENDS ON MONDAY THE 29/11 AT 23.59",
        last: "Extended sale",
        christmas: "Christmas gift guarantee",
        christmas2: "Purchase on approval until April 3",
        merry: "Merry Christmas",
        allWeek: "Christmas all day every day",
        middle: "Christmas sale",
        really: "The gifts you really wanted",
        middleDeals: "After Christmas Sale",
        newYear: "Happy New Flow",
        janSale: "SALE",
        company: "Company offers"
      },
      reviews: {
        reviews: "Reviews",
        seeReviews: "See all reviews",
        users: "Reviews from users for"
      },
      voucher: {
        success: "Your coupon was applied",
        error: "Something went wrong...",
        removed: "Your coupon was removed"
      },
      widgets: {
        topics: "Explore topics",
        subscribe: {
          title: "Subscribe",
          description: "Things are better as a Flow Member. Get first and exclusive access to the newest styles & innovation",
          label: "Sign me up",
          typeform: "SFqzvXJY"
        },
        followus: "Follow Us"
      },
      footer: {
        follow: "Follow",
        service: "Service",
        info: "Info",
        column1: {
          title: "Subscribe",
        },
        column2: {
          title: "Get help"
        },
        column3: {
          title: "Information"
        }
      },
      vip: {
        input: "Your Email address...",
        button: "Sign Up",
        title: "Black Week Early Access",
        subtitle: "Sign up to get early access for Black Week"
      },
      tracking: {
        search: "Track order",
        placeholder: "Order number",
        headline: "Track your order",
        subtitle: "Enter you order number to track your order",
        content: "Donec posuere vulputate arcu aenean posuere tortor sed cursus feugiat.",
        back: "Search again"
      },
      returns: {
        register: "Register return"
      },
      header: {
        assitance: "Assistance",
        assitanceLink: "https://support.flowlifesweden.com/hc/en-us",
      },
      search: {
        shopAll: "Shop all",
        allFilters: "All filters",
        filter: "Filter",
        clear: "Clear filters",
        bodyPart: "Body part",
        misc: "Misc",
        showResults: "Show results",
        price: "Price",
        search: "Search",
        popularSearches: "Popular searches",
        suggestions: "Suggestions",
        close: "Close",
        pillow: "Massage pillow",
        pillowSlug: "massage-pillow",
        gun: "Massage guns",
        gunSlug: "massage-guns",
        feet: "Foot massage",
        feetSlug: "foot-massager",
        pression: "Compression therapy",
        pressionSlug: "flowpression-products",
        panels: "Red light therapy",
        panelsSlug: "red-light-therapy",
        tens: "TENS",
        tensSlug: "tens",
      }
    }
  },
};

export default resources;